/** @format */

import { DocumentInterface } from '../interfaces/platform/DocumentInterface';
import { AxiosResponse } from 'axios';

export const DownloadFile = (data: any, documentFile: DocumentInterface): void => {
    if (!documentFile.file) {
        return;
    }
    const fileExt = documentFile.file.split('.').pop();
    const linkSource = `data:application/${fileExt};base64,${data}`;
    const downloadLink = document.createElement('a');
    const fileName = documentFile.file;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

export const DownloadFileFromResponse = (response: AxiosResponse<any>, documentFile: DocumentInterface): void => {
    const fileParts = response.headers['content-disposition'].split('filename=');
    const fileName = fileParts[1];
    const fileExt = fileName.split('.').pop();
    const linkSource = `data:application/${fileExt};base64,${response.data}`;
    const downloadLink = document.createElement('a');

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
